import { useState, useEffect } from 'react';
import './Screen.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse, faMagnifyingGlass, faBars, faChevronRight, faPlay, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import classNames from 'classnames';

const Screen = ({ whiteLabelSettings, hoveredSection, RenderImage }) => {
	const [delayedHoveredSection, setDelayedHoveredSection] = useState(hoveredSection);

	useEffect(() => {
		if (!hoveredSection) {
			const timeout = setTimeout(() => {
				setDelayedHoveredSection(null);
			}, 300); 

			return () => clearTimeout(timeout); 
		} else {
			setDelayedHoveredSection(hoveredSection);
		}
	}, [hoveredSection]);

	const getClassNames = (section) => {
		if (!delayedHoveredSection) {
			return '';
		}

		if (delayedHoveredSection === section || (delayedHoveredSection === "colours" && section === "watermark")) {
			return 'focused';
		}
	};

	return (
		<div className="screen">
			<div className={classNames("screen-header", getClassNames("logo"))}>
				<div className="screen-header-logo">
					{RenderImage(whiteLabelSettings.ImageFile, "Logo Preview")}
				</div>
				<FontAwesomeIcon icon={faHouse} />
				<FontAwesomeIcon icon={faMagnifyingGlass} />
				<FontAwesomeIcon icon={faBars} />
			</div>

			<div className="screen-pod">
				<div className={classNames("screen-pod-header", getClassNames("watermark"))} style={{ backgroundColor: whiteLabelSettings.PrimaryColour }}>
					{whiteLabelSettings.Gradient && <span
						className="screen-pod-header-gradient"
						style={{
							background: `linear-gradient(90deg, rgba(0,0,0,.5) 0%, ${whiteLabelSettings.PrimaryColour} 50%, ${whiteLabelSettings.PrimaryColour} 100%)`
						}}
					></span>}
					<h3 style={{ color: whiteLabelSettings.TextColour }}>Preview</h3>
					{whiteLabelSettings.WatermarkImageFile && whiteLabelSettings.ShowWatermark && (
						<div className="screen-pod-header-watermark">
							{RenderImage(whiteLabelSettings.WatermarkImageFile, "Watermark Preview")}
						</div>
					)}
				</div>
				<div className="screen-pod-main">
					<div className={classNames("screen-pod-main-content", getClassNames("colours"))}>
						<div className="screen-pod-main-content-buttons">
							<div className="screen-pod-main-content-buttons-button primary-button" style={{ borderColor: whiteLabelSettings.SecondaryColour }}>
								<p>Primary Button</p>
								<div className="screen-pod-main-content-buttons-button-arrow" style={{ backgroundColor: whiteLabelSettings.SecondaryColour }}>
									<FontAwesomeIcon icon={faChevronRight} />
								</div>
							</div>
							<div className="screen-pod-main-content-buttons-button secondary-button" style={{ borderColor: whiteLabelSettings.PrimaryColour }}>
								<p>Secondary Button</p>
								<div className="screen-pod-main-content-buttons-button-arrow" style={{ backgroundColor: whiteLabelSettings.PrimaryColour, color: whiteLabelSettings.TextColour }}>
									<FontAwesomeIcon icon={faChevronRight} />
								</div>
							</div>
							<div className="tertiary-button" style={{ color: whiteLabelSettings.PrimaryColour }}>
								<p>Tertiary Button &gt;</p>
							</div>
						</div>
						<div className="screen-pod-main-content-percentage">
							<div className="screen-pod-main-content-percentage-circle" style={{ backgroundColor: whiteLabelSettings.PrimaryColour }}>
								<span className="screen-pod-main-content-percentage-circle-percent" style={{ backgroundColor: whiteLabelSettings.SecondaryColour }} ></span>
								<span className="screen-pod-main-content-percentage-circle-cover"></span>
								<div className="screen-pod-main-content-percentage-circle-play" style={{ color: whiteLabelSettings.PrimaryColour }}><FontAwesomeIcon icon={faPlay} /></div>
							</div>
							<div className="screen-pod-main-content-percentage-circle" style={{ backgroundColor: whiteLabelSettings.SecondaryColour }}>
								<span className="screen-pod-main-content-percentage-circle-cover"></span>
								<div className="screen-pod-main-content-percentage-circle-repeat" style={{ color: whiteLabelSettings.PrimaryColour }}><FontAwesomeIcon icon={faRotateRight} /></div>
							</div>
						</div>
					</div>
					<div className={classNames("screen-pod-main-content", getClassNames("details"))}>
						{whiteLabelSettings.ContactEmail && <p><strong>Email:</strong> {whiteLabelSettings.ContactEmail}</p>}
						{whiteLabelSettings.ContactNumber && <p><strong>Phone:</strong> {whiteLabelSettings.ContactNumber}</p>}
					</div>
				</div>
			</div>
		</div>
	);
}

export default Screen;
